import axios from 'axios'
import router from '../router/index'
import { Message } from 'element-ui'
import qs from 'qs'
//请求公共地址
const urlPath = '/api/'

// 环境变量匹配接口
switch (process.env.NODE_ENV) {
    case 'production': //生产环境
        axios.defaults.baseURL = 'http://api.tougao.tdmchina.org' //测试服务
        break
    case 'test': //测试环境
        axios.defaults.baseURL = 'http://api.tougao.tdmchina.org'
        //axios.defaults.baseURL = '/screenApi'
        break
    default:
        //开发环境
        axios.defaults.baseURL = 'http://api.tougao.tdmchina.org'
        //axios.defaults.baseURL = '/screenApi'
}

// 请求超时间和是否允许跨域
axios.defaults.timeout = 1000000
axios.defaults.withCredentials = true
    /*
     * x-www-form-urlencode
     * application/json;charset=utf-8   JSON格式
     */
//axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
//axios.defaults.transformRequest = data => qs.stringify(data);
/*
设置请求拦截器
*/
axios.interceptors.request.use(
        config => {
            config.headers.XAPIVERSION = 'v1'
            let token = window.localStorage.getItem('token') ?
                window.localStorage.getItem('token') :
                'YJXC'
            token && (config.headers.Authorization = token)
            return config
        },
        error => {
            return Promise.reject(error)
        }
    )
    /**
     * 响应拦截器
     * */

axios.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        const { response } = error
        if (response) {
            switch (response.status) {
                case 400:
                    console.log('请求错误')
                    break
                    // 401: 未登录状态，跳转登录页
                case 401:
                    setTimeout(() => {
                        Ut.removeLocal('token')

                        router.push({ path: '/' })
                        Message.error('登陆超时')
                    }, 3000)

                    break
                    // 403 token过期
                    // 清除token并跳转登录页
                case 403:
                    setTimeout(() => {
                        Ut.removeLocal('token')
                        router.push({ path: '/' })
                        Message.error('登录过期，请重新登录')
                    }, 2000)
                    break
                    // 404请求不存在
                case 404:
                    // tip("请求的资源不存在");
                    break
            }
        } else {
            if (!window.navigator.onLine) {
                console.log('网络错误！')
                return
            }
            return Promise.reject(error)
        }
    }
)

export default {
    get(url, params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .get(urlPath + url, {
                    params
                })
                .then(response => {
                    // 成功处理
                    resolve(response)
                })
                .catch(err => {
                    // 失败处理
                    reject(err)
                })
        })
    },
    post(url, params, sta) {
        return new Promise((resolve, reject) => {
            axios
                .post(urlPath + url, sta ? params : qs.stringify(params))
                .then(response => {
                    // 成功处理
                    resolve(response)
                })
                .catch(err => {
                    // 失败处理
                    reject(err)
                })
        })
    },
    delete(url, params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .delete(urlPath + url, { data: params })
                .then(response => {
                    // 成功处理
                    resolve(response)
                })
                .catch(err => {
                    // 失败处理
                    reject(err)
                })
        })
    },

    put(url, params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .put(urlPath + url, params)
                .then(response => {
                    // 成功处理
                    resolve(response)
                })
                .catch(err => {
                    // 失败处理
                    reject(err)
                })
        })
    }
}
